module.exports = __webpack_public_path__ + "static/media/IconSlack.cf6ea9c5.png";